import { FC, memo } from 'react'
import type { Props } from '../types'

const AppleStore: FC<Props> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clip-path="url(#clip0_10714_56027)">
      <path
        d="M15.4909 6.71311C15.3769 6.80172 13.3641 7.93797 13.3641 10.4645C13.3641 13.3868 15.9253 14.4207 16.002 14.4463C15.9902 14.5093 15.5951 15.8622 14.6516 17.2406C13.8103 18.4537 12.9317 19.6647 11.5951 19.6647C10.2585 19.6647 9.9145 18.8869 8.3715 18.8869C6.86781 18.8869 6.33317 19.6903 5.11057 19.6903C3.88796 19.6903 3.03489 18.5679 2.05405 17.1894C0.917936 15.5707 0 13.056 0 10.6693C0 6.84111 2.48452 4.81083 4.92973 4.81083C6.22899 4.81083 7.31204 5.66548 8.12776 5.66548C8.90418 5.66548 10.115 4.75963 11.5931 4.75963C12.1533 4.75963 14.1661 4.81083 15.4909 6.71311ZM10.8914 3.13895C11.5027 2.41231 11.9351 1.40406 11.9351 0.395815C11.9351 0.256 11.9233 0.114215 11.8978 0C10.9032 0.0374154 9.7199 0.663631 9.00639 1.49268C8.44619 2.13071 7.92334 3.13895 7.92334 4.16098C7.92334 4.31458 7.94889 4.46818 7.96069 4.51742C8.02359 4.52923 8.1258 4.54302 8.22801 4.54302C9.12039 4.54302 10.2428 3.94437 10.8914 3.13895Z"
        fill="#7E8C9C"
      />
    </g>
    <defs>
      <clipPath id="clip0_10714_56027">
        <rect width="16" height="19.6923" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default memo(AppleStore)
